import { DataKeys } from "../../types";
import { getHealthProductPreviewSrc } from "./healthProductPreviewAssets";
import { getLocalized, HealthLang, LocalizedString } from "./healthTypes";
import {
    healthChildHeroProductImage,
    healthChildHeroProductImageFrame,
    healthChildHeroProductImageGlow,
    healthChildPageHeroVisual,
    healthChildPageHeroVisualInner,
    healthChildProductPreviewFrame,
    healthChildProductPreviewInner,
    healthChildProductPreviewInnerHeroCompact,
    healthChildProductPreviewInnerPrimary,
    healthChildProductPreviewPlaceholder,
} from "./healthVisualStyles";

const previewPlaceholderLabel = {
    En: "Product interface preview",
    Zh: "產品介面預覽",
    Jp: "製品UIプレビュー",
};

export type HealthProductPreviewVariant =
    | "hero"
    | "heroCompact"
    | "compact"
    | "primary"
    | "band";

interface HealthProductPreviewProps {
    visual: DataKeys | undefined;
    lang: HealthLang;
    variant?: HealthProductPreviewVariant;
}

export function HealthProductPreview({
    visual,
    lang,
    variant = "compact",
}: HealthProductPreviewProps) {
    if (!visual) {
        return null;
    }

    const alt = getLocalized(visual.alt as LocalizedString, lang);
    const assetKey = visual.assetKey as string | undefined;
    const imageSrc = getHealthProductPreviewSrc(assetKey);

    if (
        imageSrc &&
        (variant === "hero" || variant === "heroCompact")
    ) {
        return (
            <div className={healthChildHeroProductImageFrame} data-asset-key={assetKey}>
                <div className={healthChildHeroProductImageGlow} aria-hidden="true" />
                <img
                    src={imageSrc}
                    alt={alt}
                    className={healthChildHeroProductImage}
                    loading="eager"
                    decoding="async"
                />
            </div>
        );
    }

    const outerClass =
        variant === "hero"
            ? healthChildPageHeroVisual
            : healthChildProductPreviewFrame;

    const innerClass =
        variant === "hero"
            ? healthChildPageHeroVisualInner
            : variant === "heroCompact"
              ? healthChildProductPreviewInnerHeroCompact
              : variant === "primary"
                ? healthChildProductPreviewInnerPrimary
                : healthChildProductPreviewInner;

    return (
        <div className={outerClass} data-asset-key={assetKey}>
            <div className={innerClass} role="img" aria-label={alt}>
                <span className={healthChildProductPreviewPlaceholder}>
                    {getLocalized(previewPlaceholderLabel, lang)}
                </span>
            </div>
        </div>
    );
}
